module.exports = __webpack_public_path__ + "static/media/shape_3.a231d00d.png";